import { cn } from "@/lib/hooks/utils";
import { Avatar, AvatarFallback, AvatarImage } from "@/ui-components/ui/avatar";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/ui-components/ui/table";

interface RankingTableProps {
  type: "individual" | "team";
  highlightUserId?: string;
}

export function RankingTable({ type, highlightUserId }: RankingTableProps) {
  // Mock data - in a real app, this would come from an API
  const individualData = [
    {
      id: "1",
      name: "Alex Johnson",
      avatar: "/placeholder.svg?height=40&width=40",
      initials: "AJ",
      sales: 42,
      revenue: "$124,500",
      conversion: "68%",
    },
    {
      id: "2",
      name: "Sarah Williams",
      avatar: "/placeholder.svg?height=40&width=40",
      initials: "SW",
      sales: 38,
      revenue: "$118,200",
      conversion: "72%",
    },
    {
      id: "3",
      name: "Michael Brown",
      avatar: "/placeholder.svg?height=40&width=40",
      initials: "MB",
      sales: 35,
      revenue: "$105,300",
      conversion: "65%",
    },
    {
      id: "4",
      name: "Emily Davis",
      avatar: "/placeholder.svg?height=40&width=40",
      initials: "ED",
      sales: 31,
      revenue: "$92,400",
      conversion: "59%",
    },
    {
      id: "5",
      name: "David Wilson",
      avatar: "/placeholder.svg?height=40&width=40",
      initials: "DW",
      sales: 28,
      revenue: "$84,600",
      conversion: "62%",
    },
  ];

  const teamData = [
    {
      id: "1",
      name: "Enterprise Team",
      members: 8,
      sales: 124,
      revenue: "$372,500",
      conversion: "72%",
    },
    {
      id: "2",
      name: "SMB Team",
      members: 12,
      sales: 98,
      revenue: "$245,800",
      conversion: "65%",
    },
    {
      id: "3",
      name: "Startup Team",
      members: 6,
      sales: 76,
      revenue: "$182,400",
      conversion: "58%",
    },
  ];

  if (type === "individual") {
    return (
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[60px]">Rang</TableHead>
            <TableHead>Name</TableHead>
            <TableHead className="text-right">Verkäufe</TableHead>
            <TableHead className="text-right">Umsatz</TableHead>
            <TableHead className="text-right">Conversion</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {individualData.map((person, index) => (
            <TableRow key={person.id} className={cn(highlightUserId === person.id && "bg-muted font-medium")}>
              <TableCell className="font-medium">#{index + 1}</TableCell>
              <TableCell>
                <div className="flex items-center gap-2">
                  <Avatar className="h-8 w-8">
                    <AvatarImage src={person.avatar} alt={person.name} />
                    <AvatarFallback>{person.initials}</AvatarFallback>
                  </Avatar>
                  {person.name}
                  {highlightUserId === person.id && (
                    <span className="ml-2 text-xs bg-primary text-primary-foreground px-2 py-0.5 rounded-full">
                      Sie
                    </span>
                  )}
                </div>
              </TableCell>
              <TableCell className="text-right">{person.sales}</TableCell>
              <TableCell className="text-right">{person.revenue}</TableCell>
              <TableCell className="text-right">{person.conversion}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-[60px]">Rang</TableHead>
          <TableHead>Team</TableHead>
          <TableHead className="text-right">Mitglieder</TableHead>
          <TableHead className="text-right">Verkäufe</TableHead>
          <TableHead className="text-right">Umsatz</TableHead>
          <TableHead className="text-right">Conversion</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {teamData.map((team, index) => (
          <TableRow key={team.id}>
            <TableCell className="font-medium">#{index + 1}</TableCell>
            <TableCell className="font-medium">{team.name}</TableCell>
            <TableCell className="text-right">{team.members}</TableCell>
            <TableCell className="text-right">{team.sales}</TableCell>
            <TableCell className="text-right">{team.revenue}</TableCell>
            <TableCell className="text-right">{team.conversion}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
